import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";
import { Course } from "common/Labels/Course";

export default LabelProvider.create({

	MissingUser: {
		k: "organizion.missing.user.title",
		v: "Missing User"
	},

	MissingUserDescription: {
		k: "organization.missing.user.description",
		v: "Please select a user to see enrollment details."
	},

	...filters,

	SubscriptionEmpty: {
		k: "subscriptions.empty.title",
		v: "No Subscriptions Found"
	},

	SubscriptionEmptyDescription: {
		k: "subscriptions.empty.description",
		v: "Try different search parameters"
    },
		...Messages,
		...Course

});



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/UserSubscriptions.labels.ts